import React from "react";

const Cancel = ({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99956 8.93906L13.7121 5.22656L14.7726 6.28706L11.0601 9.99956L14.7726 13.7121L13.7121 14.7726L9.99956 11.0601L6.28706 14.7726L5.22656 13.7121L8.93906 9.99956L5.22656 6.28706L6.28706 5.22656L9.99956 8.93906Z"
        fill="#525866"
      />
    </svg>
  );
};

export default Cancel;
